// extracted by mini-css-extract-plugin
export default {"logout_page":"style_logout_page__+Bh-g","intro_text":"style_intro_text__wFhxV","button":"style_button__AS8F-"};